import { X } from 'lucide-react'

interface ICommonModalProps {
  hasCloseButton?: boolean /** 닫기 버튼 유무 (기본값 : true) */
  title?: string | React.ReactNode /** 모달 제목 */
  onClose: () => void /** 닫기 버튼 클릭 시 실행되는 함수 */
  topButtonText?: string /** 상단 버튼 텍스트 */
  bottomButtonText?: string /** 하단 버튼 텍스트 */
  topButtonOnClick?: () => void /** 상단 버튼 클릭 시 실행되는 함수 */
  bottomButtonOnClick?: () => void /** 하단 버튼 클릭 시 실행되는 함수 */
  modalContent?: React.ReactNode /** 모달 내용 (ex : 평가, 셀렉트 박스 등 ) */
  isTopButtonDisabled?: boolean /** 상단 버튼 비활성화 여부 (기본값 : false) */
}
const CommonModal = ({
  onClose,
  topButtonText,
  bottomButtonText,
  topButtonOnClick,
  bottomButtonOnClick,
  isTopButtonDisabled,
  title,
  modalContent,
  hasCloseButton = true
}: ICommonModalProps) => {
  return (
    <div className='fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60]'>
      <div className='bg-white rounded-2xl shadow-xl p-6 w-11/12 max-w-xs mx-auto relative border border-amber-200'>
        {hasCloseButton && (
          <button
            onClick={onClose}
            className='absolute top-4 right-4 text-amber-600 hover:text-amber-800 p-1'
            aria-label='닫기'
          >
            <X size={20} />
          </button>
        )}

        {title && <h2 className='text-lg font-semibold text-amber-900 text-center mb-6'>{title}</h2>}

        {modalContent}
        <div className=' flex flex-col gap-4'>
          <button
            onClick={topButtonOnClick}
            disabled={isTopButtonDisabled}
            className={`w-full font-medium py-3 rounded-lg transition-colors duration-150 text-sm ${
              isTopButtonDisabled
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-500 hover:to-amber-700 text-white'
            }`}
          >
            {topButtonText}
          </button>
          <button
            onClick={bottomButtonOnClick}
            className={`w-full font-medium py-3 rounded-lg transition-colors duration-150 text-sm `}
          >
            {bottomButtonText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CommonModal
